import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

const categoryImages: Record<string, string> = {
  guochan: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20and%20Korean%20drama%20collage%20with%20emotional%20scenes%2C%20warm%20lighting%2C%20cinematic%20atmosphere%2C%20romantic%20and%20dramatic%20composition%2C%20professional%20film%20aesthetic&width=600&height=400&seq=cat-img-guochan&orientation=landscape',
  jiqing: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20scene%20with%20dynamic%20composition%2C%20intense%20lighting%2C%20dramatic%20urban%20setting%2C%20cinematic%20atmosphere%2C%20warm%20orange%20and%20dark%20tones&width=600&height=400&seq=cat-img-jiqing&orientation=landscape',
  jingpin: 'https://readdy.ai/api/search-image?query=Premium%20Japanese%20Korean%20cinema%20scene%20with%20elegant%20composition%2C%20soft%20golden%20lighting%2C%20high%20quality%20film%20aesthetic%2C%20artistic%20cinematography%2C%20warm%20refined%20atmosphere&width=600&height=400&seq=cat-img-jingpin&orientation=landscape',
  jiujiu: 'https://readdy.ai/api/search-image?query=Long%20running%20TV%20series%20collage%20with%20nostalgic%20warm%20tones%2C%20classic%20shows%20collection%2C%20comforting%20familiar%20atmosphere%2C%20cozy%20viewing%20experience%2C%20timeless%20entertainment&width=600&height=400&seq=cat-img-jiujiu&orientation=landscape',
  gaoqing: 'https://readdy.ai/api/search-image?query=Ultra%20high%20definition%204K%20cinematic%20scene%20with%20crystal%20clear%20details%2C%20vibrant%20colors%2C%20sharp%20imagery%2C%20premium%20visual%20quality%2C%20modern%20streaming%20technology%20aesthetic&width=600&height=400&seq=cat-img-gaoqing&orientation=landscape',
};

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            五大专区覆盖日韩影视全品类，从日韩国产在线到日韩高清在线，总有一个频道适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-background-50 text-center">
                  {cat.name}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}